module.exports = __webpack_public_path__ + "static/polityka_prywatnosci_i_cookies-efab51b8fd6a0160d6f0e8c4f70fd527.pdf";